import { API_ENDPOINT } from "@/config/endpoint/endpoint"
import { useRequest } from 'ahooks';

// eslint-disable-next-line react-hooks/rules-of-hooks
export const useFetchBlogs = (tag: string = '') => {
  return useRequest(() => API_ENDPOINT.blogs.getBlogs(tag), {
    cacheKey: `blogs-${tag}`,
  })
}

export const useFetchBlogDetail = (id: string) => {
  return useRequest(() => API_ENDPOINT.blogs.getBlogDetail(id), {
    cacheKey: `blog-detail-${id}`,
    staleTime: 30000
  })
}

export const useFetchTags = () => {
  return useRequest(() => API_ENDPOINT.blogs.getTags(), {
    cacheKey: `tags`,
    staleTime: 30000
  })
}

export const useFetchTagDetail = (tag: string) => {
  return useRequest(() => API_ENDPOINT.blogs.getTagDetail(tag), {
    cacheKey: `tag-detail-${tag}`,
  })
}